module.exports = __webpack_public_path__ + "media/images/samples/home/news/n1-8686353650cc69946156de585ae78e3d.png";